import { render, staticRenderFns } from "./ModalSelectGroup.vue?vue&type=template&id=4f97ace0&scoped=true&"
import script from "./ModalSelectGroup.vue?vue&type=script&lang=js&"
export * from "./ModalSelectGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectGroup.vue?vue&type=style&index=0&id=4f97ace0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97ace0",
  null
  
)

export default component.exports